export default "__VITE_ASSET__CyV4caEW__"